export const actionTypes = {
    REBOOT_GATEWAY_SETTINGS: 'powertrainTools/gatewayManagement/REBOOT_GATEWAY_SETTINGS',
    REBOOT_GATEWAY: 'powertrainTools/gatewayManagement/REBOOT_GATEWAY',
    CLEAR_STORE: 'powertrainTools/gatewayManagement/rebootGateway/CLEAR_STORE'
};

export const requestType = {
    TriggerNetaReboot: 'TriggerNetaReboot',
};
